var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanCalculation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1H20C20.5523 1 21 1.44772 21 2V22C21 22.5523 20.5523 23 20 23H4C3.44772 23 3 22.5523 3 22V2C3 1.44772 3.44771 1 4 1ZM2 2C2 0.89543 2.89543 0 4 0H20C21.1046 0 22 0.895431 22 2V22C22 23.1046 21.1046 24 20 24H4C2.89543 24 2 23.1046 2 22V2ZM6 3C5.44772 3 5 3.44772 5 4V7C5 7.55228 5.44772 8 6 8H18C18.5523 8 19 7.55228 19 7V4C19 3.44772 18.5523 3 18 3H6ZM8 12H6V14H8V12ZM6 11C5.44772 11 5 11.4477 5 12V14C5 14.5523 5.44772 15 6 15H8C8.55228 15 9 14.5523 9 14V12C9 11.4477 8.55228 11 8 11H6ZM6 18H8V20H6V18ZM5 18C5 17.4477 5.44772 17 6 17H8C8.55228 17 9 17.4477 9 18V20C9 20.5523 8.55228 21 8 21H6C5.44772 21 5 20.5523 5 20V18ZM13 12H11V14H13V12ZM11 11C10.4477 11 10 11.4477 10 12V14C10 14.5523 10.4477 15 11 15H13C13.5523 15 14 14.5523 14 14V12C14 11.4477 13.5523 11 13 11H11ZM11 18H13V20H11V18ZM10 18C10 17.4477 10.4477 17 11 17H13C13.5523 17 14 17.4477 14 18V20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20V18ZM18 12H16V14H18V12ZM16 11C15.4477 11 15 11.4477 15 12V14C15 14.5523 15.4477 15 16 15H18C18.5523 15 19 14.5523 19 14V12C19 11.4477 18.5523 11 18 11H16ZM16 18H18V20H16V18ZM15 18C15 17.4477 15.4477 17 16 17H18C18.5523 17 19 17.4477 19 18V20C19 20.5523 18.5523 21 18 21H16C15.4477 21 15 20.5523 15 20V18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanCalculation);
export default __webpack_public_path__ + "static/media/Loan Calculation.f7e5774ac247ce35e06142581ef2a3fc.svg";
export { ForwardRef as ReactComponent };